import { autoPeakPicking as commonAutoPeakPicking } from 'common-spectrum';

import { references } from './references';

export function autoPeakPicking(spectrum, options = {}) {
  const { minPeakWidth = 0.01 } = options;

  const peaks = commonAutoPeakPicking(spectrum, {
    minMaxRatio: 0.005,
    sgOptions: { windowSize: 9, polynomial: 3 },
    normalizationOptions: {
      filters: [
        {
          name: 'airplsbaseline',
        },
      ],
    },
    ...options,
  })
    .filter((peak) => peak.width > minPeakWidth)
    .map((peak) => ({ energy: peak.x, count: peak.y, width: peak.width }));
  appendLabels(peaks);
  console.table(peaks);
  return peaks;
}

function appendLabels(peaks, options = {}) {
  const { maxDifference = 0.02 } = options;
  for (let peak of peaks) {
    let closest = references[0];
    let difference = Number.POSITIVE_INFINITY;
    for (let reference of references) {
      if (Math.abs(peak.energy - reference.value) < difference) {
        difference = Math.abs(peak.energy - reference.value);
        closest = reference;
      }
    }
    if (difference < maxDifference) {
      peak.element = closest.element;
      peak.transition = closest.transition;
    }
  }
}
